/**
 * Format a timestamp as relative time (e.g., "2 hours ago")
 */
export function formatAge(capturedAt: string): string {
  const now = new Date().getTime();
  const captured = new Date(capturedAt).getTime();
  const deltaMs = now - captured;

  // Handle future dates or invalid dates
  if (deltaMs < 0 || isNaN(deltaMs)) {
    return 'just now';
  }

  const seconds = Math.floor(deltaMs / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (days >= 14) {
    return `${days} days ago`;
  }
  if (days > 0) {
    return `${days} day${days > 1 ? 's' : ''} ago`;
  }
  if (hours > 0) {
    return `${hours} hour${hours > 1 ? 's' : ''} ago`;
  }
  if (minutes > 0) {
    return `${minutes} min${minutes > 1 ? 's' : ''} ago`;
  }
  return 'just now';
}
